import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { HomePage } from '../home/home.page';
import { MenuPage } from '../menu/menu.page';
import { RepositoryService } from '../../../smoothr-web-app-core/services/repository/repository.service';
import { environment } from '../../../environments/environment';
import { NavigationService } from 'src/app/services/navigation.service';
import { Location } from '@angular/common';

@Component({
	selector: 'app-cookie',
	templateUrl: './cookie.page.html',
	styleUrls: ['cookie.page.scss'],
})
export class CookiPage implements OnInit {
	static url = 'cookie';
	environment = environment;
	constructor(
		private repository: RepositoryService,
		private navigationService: NavigationService,
		private location: Location
	) {}

	ngOnInit(): void {
		this.loadCookiebotScript();
	}

	private loadCookiebotScript() {
		const scriptTag = document.createElement('script');
		scriptTag.setAttribute('src', 'https://consent.cookiebot.com/73693f7a-3ac3-4921-bda8-e4ea4aca2dde/cd.js');
		document.getElementById('cookie-declaration')?.appendChild(scriptTag);
	}
	async goBack() {
		if (this.location) {
			this.location.back();
			return;
		}
		if (this.repository._order === null) {
			await this.navigationService.home();
		} else {
			await this.navigationService.menu();
		}
	}
	static async navigate(router: Router) {
		await router.navigateByUrl(this.url);
	}

}
